export const urlTransform = (src: string) => {
	const match = src.match(/https?:\/\/.+/)
	return match ? match[0] : src
}

export function extractVideoKey(url: string) {
	if(url.includes('shorts')) {
		const parts =  url.split('shorts/')
		return parts[1].split('?')[0]
	}

	const parts = url.split('?')

	const queryParams = parts[1].split('&')

	for (let i = 0; i < queryParams.length; i++) {
		const param = queryParams[i].split('=')
		if (param[0] === 'v') {
			return param[1]
		}
	}

	return null
}

export function extractVideoKeyBe(url: string) {
	if(url.includes('si')) {
		const parts =  url.split('/')
		return parts[parts.length - 1]
	}
	return null
}

export function extractVideoKeyVK(url: string) {
	const match = url.match(/video-(\d+)_(\d+)/);
	if(match === null) return null
	const oid = match[1]; // 73154028
  const id = match[2];  // 456244015
  return `oid=-${oid}&id=${id}`;
}

